import { Tooltip } from "bootstrap";
import { initValidation } from "@/validation/Validation";
import { tryInitPageScript } from "@/pages/PageHelper";

// Side-effect imports
import "bootstrap";
//import "bootstrap/dist/css/bootstrap.min.css"; //Disabled: Bootstrap CSS is imported separately to avoid a Flash Of Unstyled Content in dev mode
import "@/styles/site.scss";
import "@/styles/material_symbols/material-symbols.scss";
import "@/styles/material_symbols/generated/material-symbols-codepoints.g.scss";
import "@/styles/APNavMenu.scss";
import "@/styles/AppNavMenu.scss";

function initBootstrapTooltips()
{
    window.addEventListener("load", event =>
    {
        const tooltipElements: NodeListOf<Element> = document.querySelectorAll('[data-bs-toggle="tooltip"]');

        for (const tooltipElement of tooltipElements)
        {
            new Tooltip(tooltipElement);
        }
    });
}

initValidation();
initBootstrapTooltips();
tryInitPageScript();
